export function export2Excel(columns, list) {
    require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');
        let tHeader = []
        let filterVal = []
        console.log(columns)
        if (!columns) {
            return;
        }
        columns.forEach(item => {
            tHeader.push(item.title)
            filterVal.push(item.key)
        })
        const data = list.map(v => filterVal.map(j => v[j]))
        export_json_to_excel(tHeader, data, '�����б�');
    })
}

// ��ǰ����
let now = new Date();
// ���챾�ܵĵڼ���
let nowDayOfWeek = now.getDay();
// ��ǰ��
let nowDay = now.getDate();
// ��ǰ��
let nowMonth = now.getMonth();
// ��ǰ��
let nowYear = now.getYear();
nowYear += (nowYear < 2000) ? 1900 : 0;

class DateUtils {
    static parseLongDate(dateStr) {
        return Date.parse(dateStr.replace(/-/g, '/'));
    }

    // ��ʽ�����ڣ�yyyy-MM-dd
    static formatDate(date) {
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();

        if (mymonth < 10) {
            mymonth = '0' + mymonth;
        }
        if (myweekday < 10) {
            myweekday = '0' + myweekday;
        }
        return (myyear + '-' + mymonth + '-' + myweekday);
    }

    // ��ʽ�����ڣ�yyyy-MM-dd
    static formatLongDate(date) {
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();
        let myHour = date.getHours();
        let myMin = date.getMinutes();
        let mySec = date.getSeconds();

        if (mymonth < 10) {
            mymonth = '0' + mymonth;
        }
        if (myweekday < 10) {
            myweekday = '0' + myweekday;
        }
        if (myHour < 10) {
            myHour = '0' + myHour;
        }
        if (myMin < 10) {
            myMin = '0' + myMin;
        }
        if (mySec < 10) {
            mySec = '0' + mySec;
        }
        return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
    }

    // ���ĳ�µ�����
    static getMonthDays(myMonth) {
        let monthStartDate = new Date(nowYear, myMonth, 1);
        let monthEndDate = new Date(nowYear, myMonth + 1, 1);
        let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        return days;
    }

    // ��ñ����ȵĿ�ʼ�·�
    static getQuarterStartMonth() {
        let quarterStartMonth = 0;
        if (nowMonth < 3) {
            quarterStartMonth = 0;
        }
        if (nowMonth > 2 && nowMonth < 6) {
            quarterStartMonth = 3;
        }
        if (nowMonth > 5 && nowMonth < 9) {
            quarterStartMonth = 6;
        }
        if (nowMonth > 8) {
            quarterStartMonth = 9;
        }
        return quarterStartMonth;
    }

    // ��ñ��ܵĿ�ʼ����
    static getWeekStartDate() {
        let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
        return this.formatDate(weekStartDate);
    }

    // ��ñ��ܵĽ�������
    static getWeekEndDate() {
        let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
        return this.formatDate(weekEndDate);
    }

    // ��ñ��µĿ�ʼ����
    static getMonthStartDate() {
        let monthStartDate = new Date(nowYear, nowMonth, 1);
        return this.formatDate(monthStartDate);
    }

    // ��ñ��µĽ�������
    static getMonthEndDate() {
        let monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth));
        return this.formatDate(monthEndDate);
    }

    // ��ñ����ȵĿ�ʼ����
    static getQuarterStartDate() {
        let quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(), 1);
        return this.formatDate(quarterStartDate);
    }

    // ��ı����ȵĽ�������
    static getQuarterEndDate() {
        let quarterEndMonth = this.getQuarterStartMonth() + 2;
        let quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth));
        return this.formatDate(quarterStartDate);
    }
    static getDateWeek(date) {
        let week = ['����', '��һ', '�ܶ�', '����', '����', '����', '����'];
        return week[date.getDay()];
    }


    static utc2beijing(utc_datetime) {
        // תΪ������ʱ���ʽ ��-��-�� ʱ:��:��
        let T_pos = utc_datetime.indexOf('T');
        let Z_pos = utc_datetime.indexOf('Z');
        let year_month_day = utc_datetime.substr(0, T_pos);
        let hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
        let new_datetime = year_month_day + " " + hour_minute_second; // 2017-03-31 08:02:06
        // ������Ϊʱ���
        timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp / 1000;
        // ����8��Сʱ������ʱ���utcʱ���˸�ʱ��
        let timestamp = timestamp + 8 * 60 * 60;
        // ʱ���תΪʱ��
        let date = new Date(parseInt(timestamp) * 1000);
        //let beijing_datetime =date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        let beijing_datetime = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;

        return beijing_datetime; // 2017-03-31 16:02:06
    }


}
export default DateUtils;